<mat-nav-list
  adEl
  style="
    width: 56px;
    min-width: 56px;
    padding: 8px 0;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: var(--mat-toolbar-container-background-color);
    height: 100%;
  "
>
  <a
    adEl="homeLink"
    mat-icon-button
    matTooltip="Home"
    matTooltipPosition="right"
    routerLink="/home"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">home</mat-icon>
  </a>
  <a
    adEl="docsLink"
    mat-icon-button
    matTooltip="Documents"
    matTooltipPosition="right"
    routerLink="/documents"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">menu_book</mat-icon>
  </a>
  <a
    adEl="newsLink"
    mat-icon-button
    matTooltip="News"
    matTooltipPosition="right"
    routerLink="/news"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">newspaper</mat-icon>
  </a>
  <a
    adEl="eventsLink"
    mat-icon-button
    matTooltip="Events"
    matTooltipPosition="right"
    routerLink="/events"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">event</mat-icon>
  </a>
  <a
    adEl="discussionsLink"
    mat-icon-button
    matTooltip="Discussions"
    matTooltipPosition="right"
    routerLink="/discussions"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">forum</mat-icon>
  </a>
  <a
    adEl="supportLink"
    mat-icon-button
    matTooltip="Support"
    matTooltipPosition="right"
    routerLink="/support"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">support_agent</mat-icon>
  </a>
  <a
    adEl="packagesLink"
    mat-icon-button
    matTooltip="Packages"
    matTooltipPosition="right"
    routerLink="/packages"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">deployed_code</mat-icon>
  </a>
  <a
    adEl="searchLink"
    mat-icon-button
    matTooltip="Search"
    matTooltipPosition="right"
    routerLink="/search"
    routerLinkActive="active-link"
  >
    <mat-icon adEl class="material-symbols-outlined">search</mat-icon>
  </a>
</mat-nav-list>
